import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    ACCOUNTING_AREA_ID_MARKER,
    processRequestForAccountingAreaWithReplacement,
} from './network/managedRequestForAccountingArea';
import { API } from '../constants';
import { PbDispatch } from './index';
import { PbRequest } from './pbRequest';

export type PartnerInvoiceType = 'UNKNOWN' | 'MINIMUM_USAGE';
export type PartnerInvoiceLifecycle = 'INVOICE' | 'CANCELLATION' | 'CORRECTION';
export type PartnerInvoiceAccountingStatus =
    | 'INTERNAL'
    | 'FILED'
    | 'CANCELED'
    | 'CORRECTED'
    | 'CUSTOM_FILED';

export type PartnerInvoiceDto = {
    invoice_id: number;
    year: number;
    month: number;
    invoice_number: string;
    amount: number;
    currency_code: string;
    accounting_status: PartnerInvoiceAccountingStatus;
    lifecycle: PartnerInvoiceLifecycle;
    linked_invoice_id?: number;
    linked_invoice_number?: string;
    type: PartnerInvoiceType;
    download_token: string;
};

type PartnerInvoicesResponse = {
    partner_invoices: PartnerInvoiceDto[];
};

interface PartnerInvoiceStore {
    partnerInvoices: PartnerInvoicesResponse | undefined;
}

const initialState: PartnerInvoiceStore = {
    partnerInvoices: undefined,
};

export const partnerInvoiceSlice = createSlice({
    name: 'partnerInvoice',
    initialState,
    reducers: {
        setPartnerInvoices(
            state: PartnerInvoiceStore,
            action: PayloadAction<PartnerInvoicesResponse>
        ) {
            state.partnerInvoices = action.payload;
        },
    },
});

export function LoadPartnerInvoices() {
    return async (dispatch: PbDispatch) => {
        const result =
            await processRequestForAccountingAreaWithReplacement<PartnerInvoicesResponse>(
                dispatch,
                `${API}/accounting_area/${ACCOUNTING_AREA_ID_MARKER}/partner_invoice`,
                {},
                PbRequest.LOAD_PARTNER_INVOICES
            );
        dispatch(partnerInvoiceSlice.actions.setPartnerInvoices(result));
    };
}

export default partnerInvoiceSlice.reducer;
